import { render } from "./TranslatedDocsView.vue?vue&type=template&id=61658660"
import script from "./TranslatedDocsView.vue?vue&type=script&lang=js"
export * from "./TranslatedDocsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__